import styled from "styled-components";

const MainContainerStyled = styled.div`
    position:relative;
    height: 100vh;
    min-height: 50vw;
    max-height: 56.25vw;
    margin-bottom:-4rem; 
`

export default MainContainerStyled;